export const GET_STORES = "GET_STORES";
